const validate = (values) => {
  const errors = {}
  const requiredFields = [
    'password',
    'email',
    'confirmPassword'
  ]

  requiredFields.forEach((field) => {
    if (!values[ field ]) {
      errors[ field ] = `Please enter ${field.toLowerCase().replace(/_/g, ' ')}`
    }
  })

  if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i.test(values.email)) {
    errors.email = 'Please enter a valid email'
  }

  if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'Password does not match'
  }

  if (!values.confirmPassword) {
    errors.confirmPassword = 'Please re-enter the password'
  }

  return errors
}

export default validate



// WEBPACK FOOTER //
// ./src/views/SignUp/validate.js